import cssVars from "css-vars-ponyfill"
cssVars({
    // Options...
})

import Vue from "vue"
import App from "./App.vue"

// site is in a subfolder on live, so make paths work
const base_path = process.env.NODE_ENV === "production" ? "/3by23/" : "/"
Vue.prototype.$basePath = base_path

window.axios = require("axios")

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"

Vue.config.productionTip = false

import ButtonLink from "@/components/ButtonLink.vue"
Vue.component("ButtonLink", ButtonLink)

Vue.mixin({
    data: function() {
        return {
            get donateOnlineURL() {
                return "https://webtopup.kilkennycollege.ie/donations/#!/"
            },
            get pledgeFormURL() {
                return `${base_path}kilkenny_college_pledge_form.pdf`
            },
            get brochureURL() {
                return `${base_path}kilkenny_college_fundrasing_programme.pdf`
            },
            get standingOrderURL() {
                return `${base_path}kilkenny_college_standing_order_mandate.pdf`
            },
            get enduringCertificateURL() {
                return `${base_path}kilkenny_college_chy3_enduring_certificate.pdf`
            }
        }
    }
})

new Vue({
    render: h => h(App)
}).$mount("#app")
